module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"fund_search":{"description":"Finden Sie passende Fonds nach Ihren Kriterien","search":{"button":"Fondssuche starten","placeholder":"WKN, ISIN oder Name"},"title":"Fondssuche"}}}}}}')
  delete Component.options._Ctor
}
